export default "__VITE_ASSET__LM22vMJ___"